import { useNavigate } from "react-router-dom";
import { HOME, WORKSPACES } from "../../routes.ts";
import { useWorkspaceUuid } from "./useWorkspaceUuid.ts";

export const useRedirectToHome = () => {
  const navigate = useNavigate();
  const workspaceUuid = useWorkspaceUuid();
  return () => navigate(`${WORKSPACES}/${workspaceUuid}/${HOME}`);
};
